import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MenuService } from './app.menu.service';
import { AppService } from './core/services/app.service';
import { FocuslinkService } from './core/services/focuslink.service';
import { GoogleAnalyticsService } from './core/services/google-analytics.service';
import { LocalDataStoreService } from './core/services/local-data-store.service';
import { NavigationService } from './core/services/navigation.service';
import { UserService } from './core/services/user.service';
import { OOVenueService } from './core/services/venue-service';
import { User, UserVenue } from './shared/models/user.model';

declare let gtag: Function;

@Component({
	selector: 'app-main',
	templateUrl: './app.main.component.html',
})
export class AppMainComponent implements OnInit, OnDestroy {
	@ViewChild('tableColumnOverlayPanelDisplay') tableColumnOverlayPanelDisplay: OverlayPanel;
	colorScheme = 'light';
	configActive: boolean;
	configClick: boolean;

	displayAdvertisement: boolean;

	inputStyle = 'filled';

	menuClick: boolean;
	menuHoverActive = false;
	menuMode = 'static';
	menuTheme = 'layout-sidebar-white';
	moment: any = moment;

	notificationMenuClick: boolean;

	overlayMenuActive: boolean;

	releaseNoteUrl: string;
	resetMenu: boolean;
	rightMenuActive: boolean;
	rightMenuClick: boolean;
	ripple: boolean;

	search = false;
	searchClick = false;
	staticMenuDesktopInactive: boolean;
	staticMenuMobileActive: boolean;
	subscriptions: Subscription = new Subscription();

	topbarNotificationMenuActive: boolean;
	topbarUserMenuActive: boolean;

	user: User;
	userMenuClick: boolean;
	userSessionTrigger: boolean;

	venues: UserVenue[];
	venueToolsDisplaySubscription = new Subscription();
	venueToolsDisplay: boolean = false;

	constructor(
		private menuService: MenuService,
		private primengConfig: PrimeNGConfig,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService,
		public userService: UserService,
		private googleAnalytics: GoogleAnalyticsService,
		private router: Router,
		public navigationService: NavigationService,
		public venueService: OOVenueService,
		public app: AppService
	) {}

	ngOnInit() {
		console.clear();
		this.primengConfig.ripple = true;
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				gtag('config', 'G-XZ9NMEKSX3', {
					page_path: event.urlAfterRedirects,
				});
			}
		});

		this.subscriptions.add(
			this.app.tableColumnOverlayPanelDisplay.subscribe((data) => {
				if (data) {
					this.tableColumnOverlayPanelDisplay.show(data);
				}
			})
		);

		this.userSessionNotify();
		this.userAdvertisementNotify();

		this.init();
		console.log(environment.version);
	}

	ngOnDestroy() {
		this.venueToolsDisplaySubscription.unsubscribe();
	}

	async init() {
		this.user = await this.localStorage.get('user');
		this.googleAnalytics.event('user_login', 'userEvent', 'login', this.user.key);
		await this.releaseNotes();
		this.venueToolsDisplaySubscription.add(this.venueService.displayVenueTools.subscribe((data) => (this.venueToolsDisplay = data)));
	}

	async releaseNotes() {
		const resp = await this.focuslink.adminCommandCenterReleaseNotesGet();

		if (this.userService.user.key) {
			if (!this.userService.user.hideReleaseNotes) {
				this.releaseNoteUrl = resp.releaseNoteUrl;
			}
		} else {
			this.userService.userSubscription.subscribe((user) => {
				if (!user.hideReleaseNotes) {
					this.releaseNoteUrl = resp.releaseNoteUrl;
				}
			});
		}
	}

	async releaseNotesHide() {
		this.userService.user.hideReleaseNotes = true;
		this.releaseNoteUrl = undefined;
		await this.focuslink.userEdit(this.userService.user);
	}

	async userSessionNotify() {
		this.userService.sessionAgeDuration.subscribe(async (data) => {});
	}

	async userAdvertisementNotify() {
		this.displayAdvertisement = this.userService.userAdvertisement.getValue();
		this.userService.userAdvertisement.subscribe(async (data) => {
			this.displayAdvertisement = data;
		});
	}

	onLayoutClick() {
		if (!this.searchClick) {
			this.search = false;
		}

		// if (!/* this.user */MenuClick) {
		// 	this.topbarUserMenuActive = false;
		// }

		if (!this.notificationMenuClick) {
			this.topbarNotificationMenuActive = false;
		}

		if (!this.rightMenuClick) {
			this.rightMenuActive = false;
		}

		if (!this.menuClick) {
			if (this.isSlim()) {
				this.menuService.reset();
			}

			if (this.overlayMenuActive || this.staticMenuMobileActive) {
				this.hideOverlayMenu();
			}

			this.menuHoverActive = false;
			this.unblockBodyScroll();
		}

		if (this.configActive && !this.configClick) {
			this.configActive = false;
		}

		this.searchClick = false;
		this.configClick = false;
		this.userMenuClick = false;
		this.rightMenuClick = false;
		this.notificationMenuClick = false;
		this.menuClick = false;
	}

	onMenuButtonClick(event) {
		this.menuClick = true;
		this.topbarUserMenuActive = false;
		this.topbarNotificationMenuActive = false;
		this.rightMenuActive = false;

		if (this.isOverlay()) {
			this.overlayMenuActive = !this.overlayMenuActive;
		}

		if (this.isDesktop()) {
			this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
		} else {
			this.staticMenuMobileActive = !this.staticMenuMobileActive;
			if (this.staticMenuMobileActive) {
				this.blockBodyScroll();
			} else {
				this.unblockBodyScroll();
			}
		}

		event.preventDefault();
	}

	onSearchClick(event) {
		this.search = !this.search;
		this.searchClick = !this.searchClick;
	}

	onMenuClick($event) {
		this.menuClick = true;
		this.resetMenu = false;
	}

	onTopbarUserMenuButtonClick(event) {
		this.userMenuClick = true;
		this.topbarUserMenuActive = !this.topbarUserMenuActive;

		this.hideOverlayMenu();

		event.preventDefault();
	}

	onTopbarNotificationMenuButtonClick(event) {
		this.notificationMenuClick = true;
		this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

		this.hideOverlayMenu();

		event.preventDefault();
	}

	onRightMenuClick(event) {
		this.rightMenuClick = true;
		this.rightMenuActive = !this.rightMenuActive;

		this.hideOverlayMenu();

		event.preventDefault();
	}

	onRippleChange(event) {
		this.ripple = event.checked;
	}

	onConfigClick(event) {
		this.configClick = true;
	}

	isSlim() {
		return this.menuMode === 'slim';
	}

	isOverlay() {
		return this.menuMode === 'overlay';
	}

	isDesktop() {
		return window.innerWidth > 991;
	}

	isMobile() {
		return window.innerWidth <= 991;
	}

	hideOverlayMenu() {
		this.overlayMenuActive = false;
		this.staticMenuMobileActive = false;
	}

	blockBodyScroll(): void {
		if (document.body.classList) {
			document.body.classList.add('blocked-scroll');
		} else {
			document.body.className += ' blocked-scroll';
		}
	}

	unblockBodyScroll(): void {
		if (document.body.classList) {
			document.body.classList.remove('blocked-scroll');
		} else {
			document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	}
}
